// Stroke icons of the customer design (24-unit grid, 1.8 stroke) — the path data is
// the design's own ICON registry (claude-design-raw-html/customer-dashboard/bd-core.js
// L191-222), trimmed to what the shell draws. One named file (CB-17), no icon font.
export const ICON = {
  home: 'M3 10.2a2 2 0 0 1 .71-1.53l7-6a2 2 0 0 1 2.58 0l7 6A2 2 0 0 1 21 10.2V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM9.5 21v-6.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V21',
  bookings: 'M5 4h14a1 1 0 0 1 1 1v15l-4-2.4-4 2.4-4-2.4L4 20V5a1 1 0 0 1 1-1M8.5 9.5h7M8.5 13.5h4',
  saved: 'M12 20.4 4.7 13.1a4.7 4.7 0 0 1 6.6-6.6l.7.7.7-.7a4.7 4.7 0 0 1 6.6 6.6z',
  reviews: 'm12 4.5 2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4L4.2 10.2l5.4-.8z',
  account: 'M12 12a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6M4.5 20c1.3-3.6 4.2-5.4 7.5-5.4s6.2 1.8 7.5 5.4',
  help: 'M8.5 8.4a3.5 3.5 0 1 1 3.5 3.6v2.4M12 19.4h.02',
  more: 'M6 12h.01M12 12h.01M18 12h.01',
  // Messages / claims are not in the design registry (DR-38 keeps them); drawn in the
  // same stroke style.
  messages: 'M4.5 6.5A2 2 0 0 1 6.5 4.5h11a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H10l-4.5 3.5v-3.5h0a1 1 0 0 1-1-1z',
  claims: 'M4 21V5.8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1V21M14 11h5.2a1 1 0 0 1 1 1v9M3 21h18M7.4 9h3M7.4 13h3M7.4 17h3',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14M20.5 20.5l-4.6-4.6',
  bell: 'M10.27 20a2 2 0 0 0 3.46 0M3.26 14.33A1 1 0 0 0 4 16h16a1 1 0 0 0 .74-1.67C19.41 12.96 18 11.5 18 7A6 6 0 0 0 6 7c0 4.5-1.41 5.96-2.74 7.33',
  chevronDown: 'm6 9.75 6 5.5 6-5.5',
  chevronRight: 'm9 5 7 7-7 7',
  close: 'M6 6l12 12M18 6 6 18',
  signOut: 'M15 17l5-5-5-5M20 12H9M12 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6',
  // Business dashboard / Add your business (not in the design registry; same stroke style).
  business: 'M4 9.5 5.2 5a1 1 0 0 1 1-.75h11.6a1 1 0 0 1 1 .75L20 9.5M4 9.5h16M4 9.5V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.5M9.5 20v-5h5v5',
  shield: 'M12 3.4 19 6v5.4c0 4.2-2.9 7.7-7 9.2-4.1-1.5-7-5-7-9.2V6z',
  offline: 'M4 4l16 16M8.5 15.5a5 5 0 0 1 7 0M5 12a10 10 0 0 1 4-2.4M19 12a10 10 0 0 0-7-2.9M12 19h.01',
} as const;

export type IconName = keyof typeof ICON;

export function Icon({ name, size = 16, stroke = 1.8 }: { name: IconName; size?: number; stroke?: number }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={ICON[name]} />
    </svg>
  );
}
